export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Ricardo P.',
    'Docente de Energía Nuclear — México D.F., México',
    'Mis alumnos por fin entienden la diferencia entre radiactividad, fisión y aplicaciones nucleares, y cómo se conectan con la realidad. Antes yo misma perdía tiempo buscando cómo explicar correctamente estos conceptos complejos. Ahora entro al aula con todo listo.',
  ],
  [
    'MG',
    'Mariana G.',
    'Profesor de Física Nuclear — Santiago, Chile',
    'Nunca más llegué a una clase sin saber cómo explicar seguridad nuclear, reactores o residuos radiactivos. El material hace el trabajo pesado por mí.',
  ],
  [
    'TL',
    'Tomás L.',
    'Docente de Ciencias — Bogotá, Colombia',
    'Las planificaciones me ahorran horas. Los proyectos sobre energía nuclear están organizados paso a paso. No improviso nunca más frente a mis alumnos.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'MR',
    'Mariana R.',
    'Docente de Energía Nuclear | Lima, Perú',
    'El material sobre fisión y producción de energía le cambió la cara a mis alumnos. Por fin entienden cómo funciona realmente. Es el recurso más claro que encontré para este tema. Lo uso desde la primera clase y los engancha de inmediato.',
  ],
  [
    'JC',
    'Jorge C.',
    'Profesor de Física | Montevideo, Uruguay',
    'El banco de 150 actividades vale por sí solo el precio del pack. Nunca más improviso una clase. Salgo de cada trimestre con la satisfacción de tener todo resuelto y mis alumnos motivados.',
  ],
  [
    'FG',
    'Fernando G.',
    'Docente de Ciencias | Caracas, Venezuela',
    'Los 100 casos prácticos transformaron cómo mis alumnos aprenden. Ahora analizan decisiones reales sobre energía nuclear, comprenden la seguridad y evalúan alternativas. Lo aplican directamente a debates reales. Eso no lo encontré en ningún otro material.',
  ],
  [
    'LM',
    'Laura M.',
    'Docente universitaria | Buenos Aires, Argentina',
    'El kit de evaluación me devolvió el tiempo de clase. Antes perdía mucho tiempo armando exámenes. Ahora tengo todo listo, coherente y vinculado con los contenidos. Mis alumnos saben exactamente qué van a ser evaluados.',
  ],
  [
    'PP',
    'Pablo P.',
    'Profesor de Energía Nuclear | Quito, Ecuador',
    'El glosario de conceptos y mitos fue una revelación. Mis alumnos finalmente entienden qué es ciencia y qué es mito. Desarrollan pensamiento crítico, cuestionan ideas previas, y comprenden la energía nuclear desde una perspectiva científica. Eso cambió completamente su relación con el tema.',
  ],
];
